/**
 * The date formatters templates use, previously registered from angular's `$filter('date')`.
 *
 * Formats are the moment equivalents of the angular patterns they replace, and, like the angular
 * filter, a value which is not a date is passed through untouched instead of rendering
 * "Invalid date".
 *
 * Templates reach these as `$gbdate` and friends - see vue/filters/globalHelpers.
 */

import moment from 'moment';

function formatDate (value, format) {
    if (value === undefined || value === null || value === '') {
        return '';
    }
    const parsed = moment(value);
    if (!parsed.isValid()) {
        return value;
    }
    return parsed.format(format);
}

const gbdate = date => formatDate(date, 'DD/MM/YYYY');                    // angular: dd/MM/yyyy
const GBDateTime = date => formatDate(date, 'DD/MM/YYYY h:mm A');         // angular: dd/MM/yyyy h:mm a
const gbtime = date => formatDate(date, 'h:mm A');                        // angular: h:mm a
const activityDate = date => formatDate(date, 'D MMM YYYY, h:mm:ss A');   // angular: d MMM y, h:mm:ss a

export { gbdate, GBDateTime, gbtime, activityDate, formatDate };
